import { render, staticRenderFns } from "./BuyerAccountDetails.vue?vue&type=template&id=01fd1128&scoped=true"
import script from "./BuyerAccountDetails.vue?vue&type=script&lang=js"
export * from "./BuyerAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountDetails.vue?vue&type=style&index=0&id=01fd1128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd1128",
  null
  
)

export default component.exports